import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9uwahrnma5: FaireBrandEntity = {
  token: "b_9uwahrnma5",
  type: "brand",
  name: "Butterface",
  avatarUrl:
    "https://cdn.faire.com/fastly/1d61fddbe94981534abdd51b051614ba0af6bb1ac7f136a67cef0317df5c9895.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/484e400d7fd86f4701203c94849da71f1d8724e3a4e29153fcb940cf896ddd6a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1d61fddbe94981534abdd51b051614ba0af6bb1ac7f136a67cef0317df5c9895.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/484e400d7fd86f4701203c94849da71f1d8724e3a4e29153fcb940cf896ddd6a.png",
  location: "Somerville, MA, USA",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 10,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi - I'm Emily, the founder of Butterface. For years, I swiped on that classic peppermint balm (you know the one) - until I read the label. Soybean oil. Canola oil. Mystery sourcing. 🚩\n\n🙅‍♀️ Turns out the beauty industry runs on mystery ingredients and impossible standards.\n\nButterface was born out of a simple idea: skincare should be clean and effective - without fillers or toxins.\n\n✨ Minimal, But Mighty\nWe believe in real ingredients, sustainable packaging, and rejecting toxic beauty standards. Butterface isn’t just a balm — it’s a movement to reclaim what goes on our lips (and into our bodies). ⚡ It’s our rebellion against toxic beauty culture — because your lips deserve better, and so do you.💋",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:57.636Z",
    importedBy: "entity-db-cli",
  },
};
